import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { NotificationService } from './notification.service';

@Injectable({

  providedIn: 'root'

})

export class GurdServiceService {
  encryptionKey = environment.encryptionKey;

  constructor() { }

  gettoken() {
    return !!localStorage.getItem("Session");
  }

  encrypt(value: string | number): string {

    return CryptoJS.AES.encrypt(value.toString(), this.encryptionKey).toString();

  }

  decrypt(value: any): string {
    return value != null ? CryptoJS.AES.decrypt(value, this.encryptionKey).toString(CryptoJS.enc.Utf8) : '';

    // try {
    //   return value != null ? CryptoJS.AES.decrypt(value, this.encryptionKey).toString(CryptoJS.enc.Utf8) : '';
    // } catch (error) {
    //   window.localStorage.clear();
    //   this.router.navigate(['/login']);
    //   this.notificationService.showError('خطایی رخ داده است , لطفا مجددا وارد شوید');
    //   return ''
    // }

  }

}
